export default "__VITE_ASSET__HeTvNqIx__"